import React, { useState } from 'react';
import Modal from '../../../../components/Modal';
import get from '../../../../helpers/data_layer/get';

const SuccessGuaranteeSellingPointFrench = ({ sellingPoint }) => {
  const [showDialog, setShowDialog] = useState(false);

  const close = () => setShowDialog(false);
  const open = () => setShowDialog(true);

  return (
    <>
      <button
        onClick={open}
        type="button"
        className="button button--link product-selector__selling-points-success-guarantee"
      >
        {sellingPoint}
      </button>
      {showDialog ? (
        <Modal
          close={close}
          showDialog={showDialog}
          modalLabelText="Garantie de réussite"
          id="success-guarantee"
          initialFocus=".modal__close"
        >
          <p className="success-guarantee__para">
            Avec plus de 2 millions d&apos;utilisateurs enregistrés, nous sommes
            convaincus que vous trouverez ce que vous cherchez sur Appartager et
            que le pass premium vous donnera un avantage considérable en vous
            permettant de trouver votre logement le plus rapidement possible.
          </p>
          <p className="success-guarantee__para">
            Si, pour quelque raison que ce soit, vous ne parvenez pas à obtenir
            ce que vous recherchez avec votre pass de 4 semaines, et à condition
            que vous n&apos;ayez pas suspendu votre pass premium initial, nous
            vous offrirons 4 semaines supplémentaires gratuites (Garantie de
            réussite) ! Pour en bénéficier, il vous suffit de nous contacter
            dans les 3 jours suivant la fin de votre pass premium de 4 semaines.
          </p>
          <p className="success-guarantee__para">
            Veuillez noter que la garantie de réussite ne peut être demandée
            qu&apos;une seule fois pour chaque achat de pass de 4 semaines que
            vous effectuez et qu&apos;il ne peut être suspendu.
          </p>
        </Modal>
      ) : null}
    </>
  );
};

export default SuccessGuaranteeSellingPointFrench;
